import type { Theme } from "@mui/material/styles";

const styles = (theme: Theme) => ({
  dialogRoot: {
    minWidth: 400,
    minHeight: 20,
    paddingBottom: 2,
  },
  dialogContentContainer: {
    display: "flex",
    flexDirection: "column",
  },
  dialogTempMessage: {
    width: "350px",
    [theme.breakpoints.down("sm")]: {
      width: "auto",
    },
  },
  dialogMedia: {
    width: "450px",
    [theme.breakpoints.down("sm")]: {
      width: "auto",
    },
  },
  dialogTitle: {
    marginBottom: 0,
    fontWeight: "bold",
    marginTop: -32,
    width: "85%",
  },
  dialogContent: {
    padding: 20,
    fontSize: 16,
  },
  dialogFooter: {
    display: "flex",
    justifyContent: "flex-end",
    paddingTop: 10,
    paddingRight: 5,
    gap: "10px",
    "& > button": {
      maxWidth: 130,
      [theme.breakpoints.down("sm")]: {
        maxWidth: "100%",
      },
    },
  },
  dialogButtons: {
    display: "flex",
    flexWrap: "wrap-reverse",
    justifyContent: "flex-end",
    gap: "10px",
    "& > button": {
      maxWidth: 130,
      [theme.breakpoints.down("sm")]: {
        maxWidth: "100%",
      },
    },
  },
  dialogButton: {
    marginRight: 10,
    fontSize: 14,
  },
  rowContainer: {
    display: "flex",
    alignItems: "center",
  },
  cellFocus: {
    cursor: "pointer",
    // width: "20vw",
  },
  selectableCell: {
    textAlign: "center",
    color: "red",
    "& .MuiTableCell-root": {
      paddingLeft: 0,
      paddingRight: 0,
    },
  },
  stopContactCell: {
    cursor: "pointer",
    // width: "20vw",
    minWidth: 100,
    flex: 1,
  },
  resize: {
    fontSize: 16,
  },
  datePicker: {
    padding: 4,
    width: 120,
    height: 31,
    borderColor: theme.palette.black.border,
    borderWidth: 1,
    borderRadius: 4,
    fontSize: 14,
  },
  recDatePicker: {
    width: 120,
    height: 26,
  },
  recDatePickerWrapper: {
    "& .react-datepicker__calendar-icon": {
      width: "0.75em",
      height: "0.75em",
      padding: "2px",
    },
    "& .react-datepicker__view-calendar-icon input": {
      paddingLeft: "18px",
    },
  },
  boderColor: {
    border: `1px solid ${theme.palette.redAlert[50]}`,
  },
  disabledBox: {
    pointerEvents: "none",
    opacity: 0.5,
  },
  disabledInput: {
    "& .MuiInputBase-input.Mui-disabled": {
      cursor: "not-allowed",
    },
  },

  megiaMgtRowContainer: {
    display: "flex",
    gap: 10,
    "& > button": {
      width: "auto",
    },
  },

  formControl: {
    display: "flex",
    flexDirection: "column",
    gap: 5,
    "& > .MuiBox-root": {
      // maxWidth: "350px",
      [theme.breakpoints.down("sm")]: {
        maxWidth: "100%",
        width: "100%",
      },
    },
    "& > .MuiBox-root.fullWidth": {
      maxWidth: "100%",
    },
    flex: 1,
    marginTop: 1,
  },

  topDiv: {
    marginTop: 8,
  },

  textToSpeachActionContainer: {
    marginLeft: "10px",
    marginBottom: "10px",
    display: "flex",
    gap: 10,
    "& > button": {
      width: "auto",
    },
  },

  timePicker: {
    display: "flex",
    justifyContent: "space-between",
    "& > .MuiBox-root.last": {
      width: "50%",
      maxWidth: "315px",
      [theme.breakpoints.down("sm")]: {
        maxWidth: "100%",
        width: "100%",
        marginTop: 15,
      },
    },
    "& > .bold": {
      color: theme.palette.primary.main,
      fontSize: 12,
      fontWeight: 600,
    },
    flexWrap: "wrap",
    [theme.breakpoints.down("sm")]: {
      justifyContent: "normal",
    },
  },

  tabContainer: {
    borderWidth: "1px",
    borderStyle: "solid",
    borderColor: theme.palette.black.border,
    paddingLeft: 10,
    paddingRight: 10,
  },
  tabContent: {
    margin: 10,
  },
  repeatPatternContainer: {
    display: "flex",
    justifyContent: "flex-start",
    marginLeft: 20,
    fontSize: 12,
    "& .MuiFormControlLabel-label": {
      fontSize: 12,
    },
    "& .MuiFormControlLabel-root": {
      marginRight: 4,
    },
  },
  audioFileContainer: {
    display: "flex",
    flexDirection: "column",
    padding: "5px 10px",
    "& > .MuiBox-root:first-child": {
      height: "70px",
    },
  },
  player: {
    fontSize: 13,
    marginTop: "8px",
    display: "flex",
    justifyContent: "center",
  },
  playerError: {
    fontSize: 13,
    marginTop: "20px",
    display: "flex",
    justifyContent: "center",
  },
  inputRoot: {
    marginBottom: -1.5,
    marginTop: -1,
    marginLeft: -0.5,
    width: "100%",
    "@media (min-width: 1023px)": {
      "& .MuiTextField-root": {
        width: "50ch",
      },
    },
  },

  selectTable: {
    marginRight: 10,
    fontSize: 16,
    fontWeight: "bold",
  },
  textField: {
    fontSize: 14,
  },
  radioGroup: {
    display: "flex",
    flexDirection: "row",
  },
  radioReadOnly: {
    cursor: "not-allowed",
    opacity: 0.6,
    "& *": {
      pointerEvents: "none",
    },
  },
  radioEnabled: {
    cursor: "auto",
    opacity: 1,
    "& *": {
      pointerEvents: "auto",
    },
  },

  readOnlyInput: {
    "& .MuiInputBase-input": {
      cursor: "not-allowed",
    },
  },
  enabledInput: {
    cursor: "text",
  },
  cellCheckbox: {
    color: theme.palette.primary.main,
    "&.Mui-checked": {
      color: theme.palette.primary.main,
    },
  },
  expandablerow: {
    "& > *": {
      borderBottom: "unset",
    },
  },
  iconButton: {
    "&:focus": {
      outline: 0,
    },
    "&.MuiIconButton-root": {
      padding: 0,
      paddingLeft: "5px",
    },
  },
  label: {
    fontSize: 12,
    color: theme.palette.primary.main,
    fontWeight: 600,
    paddingBottom: 4,
  },
  mediaDialogTabs: {
    marginTop: 1,
    width: "100%",

    "& > .tabContainer": {
      border: `1px solid ${theme.palette.black.border}`,
      borderRadius: 8,
      borderTopLeftRadius: 0,
      borderTopRightRadius: 4,
    },

    "& > .tabContainer.textToSpeech": {
      minHeight: "auto",
      maxHeight: 450,
      overflowY: "auto",
      padding: 10,
    },

    "& > .tabContainer.uploadRecord": {
      minHeight: 230,
    },
  },
  warningText: {
    fontSize: 13,
    color: theme.palette.primary.main,
    fontWeight: 600,
    paddingBottom: 0.5,
  },
  t2sAudioPlayer: {
    textAlign: "center",
    marginTop: 10,
    "& > audio": {
      height: 30,
    },
  },
  actionContainer: {
    display: "flex",
    justifyContent: "flex-end",
    flex: 1,
    gap: "10px",
    "& > button": {
      maxWidth: 130,
      width: 130,
      [theme.breakpoints.down("sm")]: {
        maxWidth: "100%",
        width: "100%",
      },
    },
  },
  customFilterForm: {
    display: "flex",
    flexDirection: "row",
    gap: 20,
  },
  invalid: {
    fontStyle: "italic",
    "& > td": {
      cursor: "not-allowed !important",
    },
  },
});

export default styles;
